$('.img-tilt').tilt({
    maxTilt: 20,
    glare: true,
    maxGlare: .5
});


$('[data-countdown]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('%H : %M : %S'));
    });
});

$('#clock').countdown('2030/10/10', function(event) {
    $('#days').html(event.strftime('%D'));
    $('#hours').html(event.strftime('%H'));
    $('#minutes').html(event.strftime('%M'));
    $('#seconds').html(event.strftime('%S'));
});


//Filter Start Here

$(document).ready(function(){
    $(".btn-1").click(function(){
        $(".filter-1").toggleClass("filter-active");
    });
    $(".btn-2").click(function(){
        $(".filter-2").toggleClass("filter-active");
    });
    $(".btn-3").click(function(){
        $(".filter-3").toggleClass("filter-active");
    });
    $(".btn-4").click(function(){
        $(".filter-4").toggleClass("filter-active");
    });
    $(".btn-5").click(function(){
        $(".filter-5").toggleClass("filter-active");
    });
    $(".btn-6").click(function(){
        $(".filter-6").toggleClass("filter-active");
    });
    $(".btn-7").click(function(){
        $(".filter-7").toggleClass("filter-active");
    });
    $(".btn-8").click(function(){
        $(".filter-8").toggleClass("filter-active");
    });
    $(".btn-9").click(function(){
        $(".filter-9").toggleClass("filter-active");
    });
    $(".clear-filter").click(function(){
        $(".filter-activity").removeClass("filter-active");
    });
  });
  
  //Filter End Here

//Overlay Navbar Start

$(document).ready(function(){
    $(".burger-icon-otr").click(function(){
        $(".overlay-content").addClass("overlay-open");
    });
    $(".close-icon-otr").click(function(){
        $(".overlay-content").removeClass("overlay-open");
    });
});

//Overlay Navbar Start

// Heart icon start here

$(document).ready(function(){
  $(".heart1").click(function(){
      $(".heart-1").toggleClass("ri-heart-line");
      $(".heart-1").toggleClass("ri-heart-fill");
  });
  $(".heart2").click(function(){
      $(".heart-2").toggleClass("ri-heart-line");
      $(".heart-2").toggleClass("ri-heart-fill");
  });
  $(".heart3").click(function(){
      $(".heart-3").toggleClass("ri-heart-line");
      $(".heart-3").toggleClass("ri-heart-fill");
  });
  $(".heart4").click(function(){
      $(".heart-4").toggleClass("ri-heart-line");
      $(".heart-4").toggleClass("ri-heart-fill");
  });
  $(".heart5").click(function(){
      $(".heart-5").toggleClass("ri-heart-line");
      $(".heart-5").toggleClass("ri-heart-fill");
  });
  $(".heart6").click(function(){
      $(".heart-6").toggleClass("ri-heart-line");
      $(".heart-6").toggleClass("ri-heart-fill");
  });
  $(".heart7").click(function(){
      $(".heart-7").toggleClass("ri-heart-line");
      $(".heart-7").toggleClass("ri-heart-fill");
  });
  $(".heart8").click(function(){
      $(".heart-8").toggleClass("ri-heart-line");
      $(".heart-8").toggleClass("ri-heart-fill");
  });
});

// Heart icon end here

// Live Auction start here

$('#Auction').owlCarousel({
    loop:false,
    margin:24,
    dots: false,
    autoplay: false,
    nav:true,
    navText: ["<img src='/assets/img/ArrowLeft.svg'>","<img src='/assets/img/ArrowRight.svg'>"],
    responsive:{
        0:{
            items:1,
            nav:false,
            dots: true
        },
        600:{
            items:2
        },
        992:{
            items:3
        },
        1300:{
            items:4
        }
    }
});


// Live Auction End here

// Collection start here

$('#Collection').owlCarousel({
    loop:false,
    margin:24,
    dots: false,
    autoplay: false,
    nav:true,
    navText: ["<img src='/assets/img/ArrowLeft.svg'>","<img src='/assets/img/ArrowRight.svg'>"],
    responsive:{
        0:{
            items:1,
            nav:false,
            dots: true
        },
        600:{
            items:2
        },
        992:{
            items:3
        },
        1300:{
            items:3
        }
    }
});


// Collection start here





